<template>
	<EMCoreTemplate category="Core" identity="lead" entity="crm_lead"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		name: 'Lead',
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/Lead.vue